import React, { memo } from 'react';
import { AppNode, TextEditMode, NodeSize } from '@/types';
import type { Editor } from '@tiptap/react';
import { SelfWritePreviewView } from './SelfWritePreviewView';
import { SelfWriteEditView } from './SelfWriteEditView';
import { SelfWriteFullscreenView } from './SelfWriteFullscreenView';

export const SelfWriteContent: React.FC<{
  data: AppNode;
  selected: boolean;
  editMode: TextEditMode;
  editor: Editor | null;
  onEnterEdit: () => void;
  onEnterFullscreen: () => void;
  onExitToPreview: () => void;
  onExitToEdit: () => void;
  onResize: (size: NodeSize) => void;
}> = memo(({ data, selected, editMode, editor, onEnterEdit, onEnterFullscreen, onExitToPreview, onExitToEdit, onResize }) => {
  if (editMode === 'fullscreen') {
    return (
      <SelfWriteFullscreenView
        data={data}
        editor={editor}
        onClose={onExitToEdit}
      />
    );
  }

  if (editMode === 'edit') {
    return (
      <SelfWriteEditView
        nodeId={data.id}
        editor={editor}
        onEnterFullscreen={onEnterFullscreen}
        onExitEdit={onExitToPreview}
        onResize={onResize}
      />
    );
  }

  return (
    <SelfWritePreviewView
      data={data}
      editor={editor}
      onDoubleClick={onEnterEdit}
      onResize={onResize}
    />
  );
}, (prevProps, nextProps) => {
  return (
    prevProps.data.id === nextProps.data.id &&
    prevProps.selected === nextProps.selected &&
    prevProps.editMode === nextProps.editMode &&
    prevProps.editor === nextProps.editor &&
    prevProps.data.data.richContent === nextProps.data.data.richContent &&
    prevProps.data.data.textContent === nextProps.data.data.textContent &&
    prevProps.data.data.nodeSize?.width === nextProps.data.data.nodeSize?.width &&
    prevProps.data.data.nodeSize?.height === nextProps.data.data.nodeSize?.height
  );
});
